import { ChangeEvent, FC, useState } from "react";
import { useDispatch } from "react-redux";

import { changeLimitsSettings } from "./../../../store/settings/actionCreators";
import { selectFormLimitSettings } from "./../../../store/settings/selectors";
import useShallowSelector from "./../../../hooks/useShalowSelector";
import SubmissionSection from "./SubmissionSection";
import Switch from "./../../../libs/Switch";
import Radio from "./../../../libs/Radio";
import DateSection from "./DateSection";
import LimitSelect from "./../General/GeneralSelect";

import styles from "./styles.module.scss";

const Limits: FC = () => {
    const dispatch = useDispatch();
    const limitSettings = useShallowSelector(selectFormLimitSettings);
    const [IPWarning, setIPWarning] = useState<string>(limitSettings.formAvailability.disableBy.perIP.warning);
    const [limitPeriod, setLimitPeriod] = useState<string>(limitSettings.formAvailability.disableBy.perIP.interval);
    const [submissionLimit, setSubmissionLimit] = useState<number>(
        limitSettings.formAvailability.disableBy.perIP.submissionLimit,
    );

    const getSubmissionLimit = (e: ChangeEvent<HTMLInputElement>) => {
        +e.target.value >= 0 && setSubmissionLimit(+e.target.value);
    };

    const getIPWarningMessage = (e: ChangeEvent<HTMLInputElement>) => setIPWarning(e.target.value);

    const handleStateUpdate = (element: any) => {
        dispatch(
            changeLimitsSettings({
                prevState: limitSettings,
                currentState: {
                    formAvailability: {
                        ...limitSettings.formAvailability,
                        ...element,
                    },
                },
            }),
        );
    };

    return (
        <>
            <p className={styles.subTitle}>Form Availability</p>
            <div className={styles.formAvailability}>
                <div>
                    <Radio
                        checked={limitSettings.formAvailability.isActive === true}
                        onChange={() =>
                            handleStateUpdate({
                                isActive: true,
                            })
                        }
                        label="Enable"
                        labelClassName={styles.label}
                    />
                </div>
                <div>
                    <Radio
                        checked={limitSettings.formAvailability.isActive === false}
                        onChange={() =>
                            handleStateUpdate({
                                isActive: false,
                            })
                        }
                        label="Disable"
                        labelClassName={styles.label}
                    />
                </div>
            </div>

            {limitSettings.formAvailability.isActive && (
                <>
                    <div className={styles.line} />
                    <DateSection limitSettings={limitSettings} />
                    <div className={styles.line} />

                    <SubmissionSection limitSettings={limitSettings} />

                    <div className={styles.line} />

                    <div className={styles.disableByOneSubmission}>
                        <label>
                            <Switch
                                checked={limitSettings.formAvailability.disableBy.perIP.isActive}
                                onChange={() =>
                                    handleStateUpdate({
                                        disableBy: {
                                            ...limitSettings.formAvailability.disableBy,
                                            perIP: {
                                                ...limitSettings.formAvailability.disableBy.perIP,
                                                isActive: !limitSettings.formAvailability.disableBy.perIP.isActive,
                                            },
                                        },
                                    })
                                }
                            />
                            <p className={styles.subTitle}>One Submission Per IP</p>
                        </label>

                        {limitSettings.formAvailability.disableBy.perIP.isActive && (
                            <>
                                <div className={styles.inputBlock}>
                                    <label className={styles.listenLabel}>
                                        Limit of Submissions
                                        <input
                                            type={"number"}
                                            value={submissionLimit ? submissionLimit : ""}
                                            placeholder={"0"}
                                            onChange={e => getSubmissionLimit(e)}
                                            className={styles.customInput}
                                            onBlur={() =>
                                                handleStateUpdate({
                                                    disableBy: {
                                                        ...limitSettings.formAvailability.disableBy,
                                                        perIP: {
                                                            ...limitSettings.formAvailability.disableBy.perIP,
                                                            submissionLimit: submissionLimit,
                                                        },
                                                    },
                                                })
                                            }
                                        />
                                    </label>
                                    <label className={styles.listenLabel}>
                                        Interval
                                        <LimitSelect
                                            selectedItem={limitPeriod}
                                            options={{ Day: "Day", Week: "Week", Month: "Month", Year: "Year" }}
                                            isLimit
                                            setState={(newKey: string) => {
                                                setLimitPeriod(newKey);

                                                handleStateUpdate({
                                                    disableBy: {
                                                        ...limitSettings.formAvailability.disableBy,
                                                        perIP: {
                                                            ...limitSettings.formAvailability.disableBy.perIP,
                                                            interval: newKey,
                                                        },
                                                    },
                                                });
                                            }}
                                        />
                                    </label>
                                </div>

                                <label className={styles.listenLabel}>
                                    Warning Message
                                    <input
                                        type="text"
                                        value={IPWarning}
                                        onChange={e => getIPWarningMessage(e)}
                                        className={styles.customInput}
                                        onBlur={() => {
                                            handleStateUpdate({
                                                disableBy: {
                                                    ...limitSettings.formAvailability.disableBy,
                                                    perIP: {
                                                        ...limitSettings.formAvailability.disableBy.perIP,
                                                        warning: IPWarning,
                                                    },
                                                },
                                            });
                                        }}
                                    />
                                </label>
                            </>
                        )}
                    </div>
                </>
            )}
        </>
    );
};

export default Limits;
